// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface PhoneSignalLowIconSignature {
  Element: SVGSVGElement;
}

export const PhoneSignalLowIcon: TOC<PhoneSignalLowIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 22H18C17.448 22 17 21.553 17 21V5C17 4.447 17.448 4 18 4H22C22.552 4 23 4.447 23 5V21C23 21.553 22.553 22 22 22ZM7 19C7 18.447 6.553 18 6 18H3C2.447 18 2 18.447 2 19V21C2 21.553 2.447 22 3 22H6C6.553 22 7 21.553 7 21V19ZM21 20H19V6H21V20ZM14 22H10C9.448 22 9 21.553 9 21V12C9 11.447 9.448 11 10 11H14C14.552 11 15 11.447 15 12V21C15 21.553 14.553 22 14 22ZM13 20H11V13H13V20Z"/>
</svg>
</template>;